import { FieldValue } from '@/_shared/components/field-value/index.js';
import { PackedGrid } from '@/_shared/components/packed-grid/index.js';
import { Section } from '@/_shared/components/section/index.js';
import { useTsRest } from '@/_shared/context/ts-rest.js';
import { ScriptRegular } from '@fluentui/react-icons';

type ContractProps = {
    claimId: string;
};

export function Contract({ claimId }: ContractProps) {
    const tsr = useTsRest();

    const { data } = tsr.claimDetails.getClaimContract.useQuery({
        queryKey: ['claimDetails', 'getClaimContract', claimId],
        queryData: {
            params: {
                claimId,
            },
        },
        refetchInterval: 30_000,
    });

    return (
        <Section
            header={{
                label: 'Vertrag',
                color: 'lime',
                icon: <ScriptRegular />,
            }}
        >
            <PackedGrid>
                <FieldValue
                    label="VSNr"
                    value={data?.body.contractNumber}
                    copyableValue={data?.body.contractNumber}
                    nullPlaceholder="-"
                />

                <FieldValue label="Versicherungsnehmer" value={data?.body.policyholderName} nullPlaceholder="-" />

                <FieldValue label="Vermittler" value={data?.body.brokerName} nullPlaceholder="-" />

                <FieldValue label="Makler" value={data?.body.tenant} nullPlaceholder="-" />

                <FieldValue label="Risiko" value={data?.body.divisionHeader} nullPlaceholder="-" />

                <FieldValue label="Gefahr" value={data?.body.risk} nullPlaceholder="-" />

                <FieldValue label="Objekt" value={data?.body.objectHeader} nullPlaceholder="-" />

                <FieldValue label="Bedingungswerk" value={data?.body.termsAndConditions} nullPlaceholder="-" />

                <FieldValue label="Status" value={data?.body.status} nullPlaceholder="-" />
            </PackedGrid>
        </Section>
    );
}
